import React from "react";
import Navbar from "../../common/navBar/navBar.tsx";
import Contact from "../contact/contact.tsx";
import Footer from "../../common/footer/footer.tsx";
import About from "../about/about.tsx";
import HeroSection from "../../private/heroSection/heroSection.tsx";
import FAQ from "../faq/faq.tsx";
import "../../private/heroSection/heroSection.css";

const Home = () => {
  return (
    <>
      <Navbar />
      <div className='announcement-bar'>
        <div className='announcement-content'>
          ❤️ <span className='offer'>Grand Opening Offer</span>
          🎉 The <span className='highlight'>FIRST 50 MEMBERS</span> will receive
          <span className='highlight'>FREE PREMIUM MEMBERSHIP</span>
          💍 Register Today • Limited Time Only • Don't Miss this opportunity!
        </div>
      </div>
      <HeroSection />
      <About showNavbar={false} />
      <FAQ showNavbar={false} />
      <Contact showNavbar={false} />
      <Footer />
    </>
  );
};

export default Home;
